import { render, staticRenderFns } from "./subDialog.vue?vue&type=template&id=2df4ac32&scoped=true"
import script from "./subDialog.vue?vue&type=script&lang=js"
export * from "./subDialog.vue?vue&type=script&lang=js"
import style0 from "./subDialog.vue?vue&type=style&index=0&id=2df4ac32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4ac32",
  null
  
)

export default component.exports